import { render, staticRenderFns } from "./RandomPaper.vue?vue&type=template&id=075f2397&scoped=true"
import script from "./RandomPaper.vue?vue&type=script&lang=js"
export * from "./RandomPaper.vue?vue&type=script&lang=js"
import style0 from "./RandomPaper.vue?vue&type=style&index=0&id=075f2397&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "075f2397",
  null
  
)

export default component.exports